import {useCurrentOrganisation} from '~/components/CurrentOrganisationContext'

export const useShowMeetings = () => {
    const {currentOrganisation} = useCurrentOrganisation()

    const showMeetings = currentOrganisation?.appFeatures?.meetings

    return {showMeetings}
}
